const bookmarkTransition = () => {
  const bookmarks = document.querySelectorAll('.bookmark');

  if (bookmarks.length !== 0) {
    const transiteBookmark = () => {
      bookmarks.forEach((el) => {
        if (el.getBoundingClientRect().top > 30 && el.getBoundingClientRect().top < 150) {
          let prevActiveBookmark = document.querySelector('.bookmark--active');
          if (prevActiveBookmark) {
            prevActiveBookmark.classList.remove('bookmark--active');
          }
          el.classList.add('bookmark--active');
        }
      });
    };

    window.addEventListener('scroll', function () {
      transiteBookmark();
    });
  }
};

export {bookmarkTransition};
